// extracted by mini-css-extract-plugin
export default {"selectBox":"AutoCompeleWithIcon_selectBox__bnae3"};